// extracted by mini-css-extract-plugin
export default {"img_polizas":"style_img_polizas__Sv+Mu"};